import * as headTags from "./reducer";
import { updateHead } from "./actionCreator";

export const reducers = {
    head: headTags.reducer
};

export const actions = { updateHead: updateHead };

export * from "./actions";